import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Constants } from 'src/app/shared/constants';

@Injectable({
  providedIn: 'root'
})
export class StockReportsService {

  constructor(private http: HttpClient) { }
  Baseurl(): string {
    return Constants.BASE_URL;
  }
  getAllItems() {
    return this.http.get<any>(Constants.BASE_URL + 'StockReports/GetAllItems', { observe: 'response' })
  }
  postPhysicalStock(opstObject) {
    return this.http.post<any>(Constants.BASE_URL + 'StockReports/AdjustStock', opstObject, { observe: 'response' });
  }
  
  getClosingStock(opstObject): any {
    return this.http.post<any>(Constants.BASE_URL + 'StockReports/GetStockInventory', opstObject, { observe: 'response' });
  }

  getActiveItems(locationId){
    return this.http.get<any>(this.Baseurl() + Constants.GET_ACTIVE_ITEMS + '/' + locationId)
  }

  getStockLedger(opstObject): any {
    return this.http.post<any>(Constants.BASE_URL + 'StockReports/GetStockLedger', opstObject, { observe: 'response' });
  }
  getDamageStockLedger(opstObject): any {
    return this.http.post<any>(Constants.BASE_URL + 'StockReports/GetDamageStockLedger', opstObject, { observe: 'response' });
  }
  getStockBatches(opstObject): any {
    return this.http.post<any>(Constants.BASE_URL + 'StockReports/GetStockBatch', opstObject, { observe: 'response' });
  }
  getStockBatchOutwards(opstObject): any {
    return this.http.post<any>(Constants.BASE_URL + 'StockReports/GetStockBatchOutwards', opstObject, { observe: 'response' });
  }
  getItemBarCodes(inputObj): any {
    return this.http.post<any>(Constants.BASE_URL + 'StockReports/GetItemBarCodes', inputObj, { observe: 'response' });
  }
  getStockClosingBalance(opstObject): any {
    return this.http.post<any>(Constants.BASE_URL + 'StockReports/GetStockClosingBalance', opstObject, { observe: 'response' });
  }
  getStockInventory(inputObj): any {
    return this.http.post<any>(Constants.BASE_URL + 'StockReports/GetStockInventory', inputObj, { observe: 'response' });
  }

}
